import {
  ProductListResponseDto,
  ProductReferenceDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { IProductReference } from '@epicuro-next/data/product';

export const engagementListWithAvailabilityMapper = (
  items: ProductListResponseDto[],
  availableReferences: IProductReference[],
  unavailableReferences: IProductReference[],
): ProductListResponseDto[] => {
  return items.map((item) => {
    const itemCombinedReferences = item.productsReference?.map(
      (ref) => `${ref.brandId}_${ref.productId}`,
    );

    const listAvailableReferences = availableReferences.filter((ref) =>
      itemCombinedReferences?.includes(`${ref.brandId}_${ref.productId}`),
    ) as ProductReferenceDto[];

    const listUnavailableReferences = unavailableReferences.filter((ref) =>
      itemCombinedReferences?.includes(`${ref.brandId}_${ref.productId}`),
    ) as ProductReferenceDto[];
    return {
      ...item,
      availableReferences: listAvailableReferences,
      availableProductsCount: listAvailableReferences.length,
      unavailableReferences: listUnavailableReferences,
      unavailableProductsCount: listUnavailableReferences.length,
    };
  });
};
